import { useCallback, useEffect, useState } from 'react'
import { BehaviorSubject } from 'rxjs'

import { UseEntityProps } from 'src/hooks/useEntity'
import { Stores } from 'src/services/Store'

export function useIsEntityChanged<T>(
    props: UseEntityProps<T>
): [BehaviorSubject<boolean>, (value: boolean) => void] {
    const { entityId, selector } = props
    const [flag$] = useState(() => new BehaviorSubject(false))
    useEffect(
        () => Stores.get(selector)?.trackIsChanged(entityId, flag$),
        [flag$, entityId, selector]
    )

    const setIsChanged = useCallback((value: boolean) => flag$.next(value), [flag$])
    return [flag$, setIsChanged]
}
